import { render, staticRenderFns } from "./TextBlockHeader.vue?vue&type=template&id=3ae6b07f&scoped=true&"
import script from "./TextBlockHeader.vue?vue&type=script&lang=js&"
export * from "./TextBlockHeader.vue?vue&type=script&lang=js&"
import style0 from "./TextBlockHeader.vue?vue&type=style&index=0&id=3ae6b07f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae6b07f",
  null
  
)

export default component.exports